import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from '../../../../config/config.service';
import { ClientService } from '../../../shared/client/client.service';
import { ArticlePorteur } from "./articles/article";
import { Cab } from "./articles/cab";
import { Porteur } from './porteur';

@Injectable({
  providedIn: 'root'
})
export class PorteurService {

  codeService;

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private clientService: ClientService
  ) { }

  getPorteurs(filterContent: string, type: string): Observable<Array<Porteur>> {
    return this.clientService.getFirstCurrentClient().pipe(
      mergeMap(client => {
        return this.configService.getConfig().pipe(
          mergeMap(config => {
            return this.http.get<Array<Porteur>>(config.apiPoint + config.getClientPorteurs.
              replace("{client}", client.id), {
              params: {
                filter: filterContent,
                filterType: type
              }
            });
          })
        )
      })
    )
  }

  public getVTDetails(porteur: Porteur): Observable<number> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<number>(config.apiPoint + config.getClientPorteurArticle.
              replace("{client}", client.id).
              replace("{numPorteur}", porteur.numPorteur));
          }));
      })
    )
  }


  public getPorteur(porteur): Observable<Porteur> {
    if(!this.clientService.modifCodeService) throw new Error();

    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<Porteur>(config.apiPoint + config.getClientPorteur.
              replace("{client}", client.id).replace("{numPorteur}", porteur).replace("{codeService}", this.clientService.modifCodeService));
          }));
      })
    )
  }

  public getArticles(porteur: Porteur): Observable<Array<ArticlePorteur>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<Array<ArticlePorteur>>(config.apiPoint + config.getClientPorteurArticles.
              replace("{client}", client.id).
              replace("{numPorteur}", porteur.numPorteur).
              replace("{codeService}", porteur.codeService));
          }));
      })
    )
  }

  public getArticle(porteur, codeArticle, taille, codeService): Observable<ArticlePorteur> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<ArticlePorteur>(config.apiPoint + config.getClientPorteurArticle.
              replace("{client}", client.id).
              replace("{numPorteur}", porteur).
              replace("{codeArticle}", codeArticle).
              replace("{taille}", taille == ".." ? "--" : taille).
              replace('{codeService}', this.clientService.modifCodeService));
          }));

      })
    )
  }

  public getCab(porteur, article, taille): Observable<Cab> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<Cab>(config.apiPoint + config.getClientPorteurArticleCab.
              replace("{client}", client.id).
              replace("{numPorteur}", porteur).
              replace("{codeArticle}", article).
              replace("{taille}", taille == ".." ? "--" : taille).
              replace('{codeService}', this.clientService.modifCodeService));
          }));
      })
    )
  }

}
